import * as React from "react";
import {useContext, useEffect, useRef, useState} from "react";
import {IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonPage, IonToolbar} from "@ionic/react";
import TheMap from "../../components/TheMap/TheMap";
import Header from "../../components/Header/Header";
import MapContext from "../../contexts/MapContext";
import {useLocation} from "react-router-dom";
import {arrowDownOutline, arrowUpOutline, shareOutline} from "ionicons/icons";
import {AppConfig} from "../../utils/AppConfig";
import FacilityBadge from "../../components/MapOverlay/FacilityBadge";
import {Trans} from "react-i18next";
import {Feature} from "ol";

// import FacilityList from "../../components/FacilityList/FacilityList/FacilityList";
import FilterListComponent from "../../components/Filter/FilterListComponent/FilterListComponent";

import styles from './TwoColumns.module.css';
import MapTabStyles from "../MapTab.module.css";

const TwoColumns: React.FC = () => {

    const modal = useRef<HTMLIonModalElement>(null);
    const location = useLocation();
    const {getState} = useContext(MapContext);

    const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

    const searchParams = new URLSearchParams(location.search);
    const hideHeader = searchParams.get('hide-header') === 'true';

    function modalFullyOpened(): boolean {
        modal?.current?.getCurrentBreakpoint().then((bp) => {
            return bp === 1.0
        })
        return false;
    }

    function smC() {
        setModalContent(
            <>
                <IonHeader className={MapTabStyles.header}>
                    <IonToolbar className={MapTabStyles.toolbar}>
                        {(modalFullyOpened()) &&
                            <IonButtons slot="start">
                                <IonButton onClick={handleMaxModal}>
                                    <IonIcon icon={arrowUpOutline}></IonIcon>
                                    OP
                                </IonButton>
                            </IonButtons>
                        }
                        <IonButtons slot="start">
                            <IonButton onClick={share}>
                                <IonIcon icon={shareOutline}></IonIcon>
                                <Trans i18nKey={'share'}></Trans>
                            </IonButton>
                        </IonButtons>
                        <IonButtons slot="end">
                            <IonButton onClick={handleCloseModal}>
                                <IonIcon icon={arrowDownOutline}></IonIcon>
                                <Trans i18nKey={'close'}></Trans>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen>
                    <div className={MapTabStyles.flexWrapper}>
                        <FacilityBadge></FacilityBadge>
                    </div>
                </IonContent>
            </>
        )
    }

    useEffect(() => {
        if (getState().tappedFeatures.length > 0) {
            smC()
            getState().setShowFilterModal(true);
        } else {
            getState().setShowFilterModal(false);
        }
    }, [getState, getState().tappedFeatures])

    function onDismiss(x: any) {
        getState().setTappedFeatures([]);
        getState().setFeatureIdInMapOverlay(undefined);
        getState().setSelectedObjectId(undefined);
        getState().setShowFilterModal(false)
    }

    async function share() {
        const features: Feature[] = getState().allFeatures;
        let filteredFeature = features.filter(
            (o: Feature) => o.getProperties().objekt_id === getState().featureIdInMapOverlay
        )

        let ftr;
        let navn = '';
        if (filteredFeature.length > 0) {
            ftr = filteredFeature[0]
            const props = ftr.getProperties();
            navn = props.navn
        }

        const url = AppConfig.appBaseUrl + '/facility/' + getState().featureIdInMapOverlay;

        navigator.share({
            title: navn,
            text: navn,
            url: url
        });
    }

    function handleCloseModal() {
        getState().setShowFilterModal(false)
        getState().setTappedFeatures([]);
    }

    function handleMaxModal() {
        modal?.current?.setCurrentBreakpoint(1);
    }

    return (
        <IonPage>
            <div className={styles.backdrop}></div>
            {!hideHeader && <Header></Header>}
            <IonContent>
                <div className={styles.twoColumnsContainer}>
                    <div className={styles.rightColumn}>
                        <FilterListComponent></FilterListComponent>
                    </div>
                    <div className={styles.leftColumn}>
                        <TheMap mapId={'map'}></TheMap>
                    </div>
                </div>
            </IonContent>
            <IonModal
                animated={true}
                mode={'md'}
                ref={modal}
                className={MapTabStyles.mapModal}
                handleBehavior="cycle"
                keepContentsMounted={true}
                isOpen={getState().showFilterModal}
                onDidDismiss={(swiper) => onDismiss(swiper)}
                initialBreakpoint={AppConfig.modals.mapClick.initialBreakPoint}
                backdropBreakpoint={0.4}
                breakpoints={AppConfig.modals.mapClick.breakpoints}>
                {modalContent}
            </IonModal>
        </IonPage>
    )
}

export default TwoColumns;
